export default [
    {
        library: 'CodeMirror',
        librarylink: 'https://codemirror.net/',
        version: '5.19.0',
        author: 'Marijn Haverbeke',
        authorlink: 'https://github.com/marijnh',
        license: 'MIT',
        licenselink:
            'https://github.com/codemirror/CodeMirror/blob/master/LICENSE',
        githublink: 'https://github.com/codemirror/codemirror',
    },
    {
        library: 'D3',
        librarylink: 'https://d3js.org/',
        version: '3',
        author: 'Mike Bostock',
        authorlink: 'https://github.com/mbostock',
        license: 'BSD 3-Clause',
        licenselink: 'https://github.com/d3/d3/blob/master/LICENSE',
        githublink: 'https://github.com/d3/d3',
    },
    {
        library: 'D3',
        librarylink: 'https://d3js.org/',
        version: '4',
        author: 'Mike Bostock',
        authorlink: 'https://github.com/mbostock',
        license: 'BSD 3-Clause',
        licenselink: 'https://github.com/d3/d3/blob/master/LICENSE',
        githublink: 'https://github.com/d3/d3',
    },
    {
        library: 'DataTables',
        librarylink: 'https://www.datatables.net/',
        version: '1.10.16',
        author: 'DataTables',
        authorlink: 'https://github.com/DataTables',
        license: 'Custom',
        licenselink:
            'https://github.com/DataTables/DataTables/blob/master/license.txt',
        githublink: 'https://github.com/DataTables/DataTables',
    },
    {
        library: 'Highcharts JS',
        librarylink: 'https://www.highcharts.com/',
        version: '7.1.1',
        author: 'Torstein Honsi',
        authorlink: 'https://github.com/highcharts',
        license: 'CC BY-NC 3.0',
        licenselink: 'https://creativecommons.org/licenses/by-nc/3.0/',
        githublink: 'https://github.com/highcharts/highcharts',
    },
    {
        library: 'Hammer.JS',
        librarylink: 'https://hammerjs.github.io/',
        version: '2.0.8',
        author: 'Jorik Tangelder',
        authorlink: 'https://github.com/hammerjs',
        license: 'MIT',
        licenselink:
            'https://github.com/hammerjs/hammer.js/blob/master/LICENSE.md',
        githublink: 'https://github.com/hammerjs/hammer.js',
    },
    {
        library: 'mark.js',
        librarylink: 'https://markjs.io/',
        version: '8.11.1',
        author: 'Julian Kühnel',
        authorlink: 'https://github.com/julmot',
        license: 'MIT',
        licenselink: 'https://github.com/julmot/mark.js/blob/master/LICENSE',
        githublink: 'https://github.com/julmot/mark.js',
    },
    {
        library: 'jQuery',
        librarylink: 'https://jquery.com/',
        version: '1.11.3',
        author: 'jQuery Foundation, Inc.',
        authorlink: 'https://js.foundation/',
        license: 'MIT',
        licenselink: 'https://jquery.org/license/',
        githublink: 'https://github.com/jquery/jquery',
    },
    {
        library: 'Leaflet',
        librarylink: 'https://leafletjs.com/',
        version: '1.4.0',
        author: 'Vladimir Agafonkin',
        authorlink: 'https://agafonkin.com/',
        license: 'Custom',
        licenselink: 'https://github.com/Leaflet/Leaflet/blob/master/LICENSE',
        githublink: 'https://github.com/Leaflet/Leaflet',
    },
    {
        library: 'Leaflet.draw',
        librarylink:
            'https://leaflet.github.io/Leaflet.draw/docs/leaflet-draw-latest.html',
        version: '1.0.4',
        author: 'Jacob Toye, Jon West, Smartrak',
        authorlink:
            'https://leaflet.github.io/Leaflet.draw/docs/leaflet-draw-latest.html',
        license: 'MIT',
        licenselink:
            'https://github.com/Leaflet/Leaflet.draw/blob/develop/MIT-LICENSE.md',
        githublink: 'https://github.com/Leaflet/Leaflet.draw',
    },
    {
        library: 'Leaflet.PolylineDecorator',
        librarylink: 'https://github.com/bbecquet/Leaflet.PolylineDecorator',
        version: '1.6.0',
        author: 'Benjamin Becquet',
        authorlink: 'https://github.com/bbecquet',
        license: 'MIT',
        licenselink:
            'https://github.com/bbecquet/Leaflet.PolylineDecorator/blob/master/LICENSE',
        githublink: 'https://github.com/bbecquet/Leaflet.PolylineDecorator',
    },
    {
        library: 'leaflet-corridor',
        librarylink: 'https://github.com/mikhailshilkov/leaflet-corridor',
        version: '0',
        author: 'Mikhail Shilkov',
        authorlink: 'https://mikhail.io',
        license: 'MIT',
        licenselink:
            'https://github.com/mikhailshilkov/leaflet-corridor/blob/master/LICENSE',
        githublink: 'https://github.com/mikhailshilkov/leaflet-corridor',
    },
    {
        library: 'Leaflet.Editable',
        librarylink: 'http://leaflet.github.io/Leaflet.Editable/doc/api.html',
        version: '1.1.0',
        author: 'Yohan Boniface',
        authorlink: 'https://github.com/yohanboniface',
        license: 'WTFPL',
        licenselink: 'http://www.wtfpl.net/about/',
        githublink: 'https://github.com/Leaflet/Leaflet.Editable',
    },
    {
        library: 'Leaflet.ImageOverlay.Rotated',
        librarylink:
            'https://github.com/IvanSanchez/Leaflet.ImageOverlay.Rotated',
        version: '0.1.3',
        author: 'IvanSanchez',
        authorlink: 'https://github.com/IvanSanchez',
        license: 'Beerware',
        licenselink: 'https://en.wikipedia.org/wiki/Beerware',
        githublink:
            'https://github.com/IvanSanchez/Leaflet.ImageOverlay.Rotated',
    },
    {
        library: 'Leaflet.imageTransform',
        librarylink: 'https://github.com/ScanEx/Leaflet.imageTransform',
        version: '0',
        author: 'Serg',
        authorlink: 'https://github.com/originalsin',
        license: 'MIT',
        licenselink:
            'https://github.com/ScanEx/Leaflet.imageTransform/blob/master/LICENSE',
        githublink: 'https://github.com/ScanEx/Leaflet.imageTransform',
    },
    {
        library: 'Leaflet.latlng-graticule',
        librarylink: 'https://github.com/cloudybay/leaflet.latlng-graticule',
        version: '1.1',
        author: 'cloudybay',
        authorlink: 'https://github.com/cloudybay',
        license: 'MIT',
        licenselink:
            'https://github.com/cloudybay/leaflet.latlng-graticule/blob/master/LICENSE',
        githublink: 'https://github.com/cloudybay/leaflet.latlng-graticule',
    },
    {
        library: 'leaflet-pip',
        librarylink: 'https://mapbox.github.io/leaflet-pip/',
        version: '1.1.0',
        author: 'Tom MacWright',
        authorlink: 'https://macwright.org/',
        license: 'BSD 2-Clause',
        licenselink:
            'https://github.com/mapbox/leaflet-pip/blob/gh-pages/LICENSE',
        githublink: 'https://github.com/mapbox/leaflet-pip',
    },
    {
        library: 'Proj4Leaflet',
        librarylink: 'http://kartena.github.io/Proj4Leaflet/',
        version: '1.0.2',
        author: 'Kartena',
        authorlink: 'https://github.com/kartena',
        license: 'BSD 2-Clause',
        licenselink:
            'https://github.com/kartena/Proj4Leaflet/blob/master/LICENSE',
        githublink: 'https://github.com/kartena/Proj4Leaflet',
    },
    {
        library: 'Materialize',
        librarylink: 'https://materializecss.com/',
        version: '0.97.7',
        author: 'Materializes',
        authorlink: 'https://materializecss.com/',
        license: 'MIT',
        licenselink:
            'https://github.com/Dogfalo/materialize/blob/v1-dev/LICENSE',
        githublink: 'https://github.com/Dogfalo/materialize',
    },
    {
        library: 'MetricsGraphics.js',
        librarylink: 'https://metricsgraphicsjs.org/',
        version: '2.10.1',
        author: 'Metrics Graphics',
        authorlink: 'https://metricsgraphicsjs.org/',
        license: 'MPL 2.0',
        licenselink:
            'https://github.com/metricsgraphics/metrics-graphics/blob/master/LICENSE',
        githublink: 'https://github.com/metricsgraphics/metrics-graphics',
    },
    {
        library: 'NippleJS',
        librarylink: 'https://yoannmoi.net/nipplejs/',
        version: '0.7.1',
        author: 'Yoann Moinet',
        authorlink: 'https://github.com/yoannmoinet',
        license: 'MIT',
        licenselink:
            'https://github.com/yoannmoinet/nipplejs/blob/master/LICENSE',
        githublink: 'https://github.com/yoannmoinet/nipplejs',
    },
    {
        library: 'Node.js',
        librarylink: 'https://nodejs.org/',
        version: '8.11.3',
        author: 'Node.js Foundation',
        authorlink: 'https://nodejs.org/',
        license: 'Custom',
        licenselink:
            'https://raw.githubusercontent.com/nodejs/node/master/LICENSE',
        githublink: 'https://github.com/nodejs',
    },
    {
        library: 'OpenSeadragon',
        librarylink: 'https://openseadragon.github.io/',
        version: '2.2.1',
        author: 'OpenSeadragon',
        authorlink: 'https://openseadragon.github.io/',
        license: 'New BSD',
        licenselink: 'https://openseadragon.github.io/license/',
        githublink: 'https://github.com/openseadragon/openseadragon',
    },
    {
        library: 'OpenseadragonFabricjsOverlay',
        librarylink: 'https://github.com/altert/OpenseadragonFabricjsOverlay',
        version: '0.2.0',
        author: 'Alexey Tikhonov',
        authorlink: 'https://github.com/altert/',
        license: 'BSD 3-Clause',
        licenselink:
            'https://github.com/altert/OpenseadragonFabricjsOverlay/blob/master/LICENSE',
        githublink: 'https://github.com/altert/OpenseadragonFabricjsOverlay',
    },
    {
        library: 'png.js',
        librarylink: 'https://github.com/devongovett/png.js/',
        version: '0',
        author: 'Devon Govett',
        authorlink: 'https://github.com/devongovett',
        license: 'MIT',
        licenselink:
            'https://github.com/devongovett/png.js/blob/master/LICENSE',
        githublink: 'https://github.com/devongovett/png.js/',
    },
    {
        library: 'RequireJS',
        librarylink: 'https://requirejs.org/',
        version: '2.2.0',
        author: 'JS Foundation, Inc.',
        authorlink: 'https://js.foundation/',
        license: 'Custom',
        licenselink:
            'https://github.com/requirejs/requirejs/blob/master/LICENSE',
        githublink: 'https://github.com/requirejs/requirejs',
    },
    {
        library: 'shapefile',
        librarylink: 'https://github.com/mbostock/shapefile',
        version: '0.6.6',
        author: 'Mike Bostock',
        authorlink: 'https://github.com/mbostock',
        license: 'Custom',
        licenselink:
            'https://github.com/mbostock/shapefile/blob/master/LICENSE.txt',
        githublink: 'https://github.com/mbostock/shapefile',
    },
    {
        library: 'three.js',
        librarylink: 'https://threejs.org/',
        version: '89',
        author: 'Mr.doob',
        authorlink: 'https://mrdoob.com/',
        license: 'MIT',
        licenselink: 'https://github.com/mrdoob/three.js/blob/dev/LICENSE',
        githublink: 'https://github.com/mrdoob/three.js/',
    },
    {
        library: 'THREE.MeshLine',
        librarylink: 'https://github.com/spite/THREE.MeshLine',
        version: '1.1.0',
        author: 'Jaume Sanchez',
        authorlink: 'https://github.com/spite',
        license: 'MIT',
        licenselink:
            'https://github.com/spite/THREE.MeshLine/blob/master/LICENSE',
        githublink: 'https://github.com/spite/THREE.MeshLine',
    },
    {
        library: 'three.ar.js',
        librarylink: 'https://github.com/google-ar/three.ar.js',
        version: '0.1.8',
        author: 'Google AR',
        authorlink: 'https://github.com/google-ar',
        license: 'Apache-2.0',
        licenselink:
            'https://github.com/google-ar/three.ar.js/blob/master/LICENSE',
        githublink: 'https://github.com/google-ar/three.ar.js',
    },
    {
        library: 'webgl-wireframes',
        librarylink: 'https://github.com/mattdesl/webgl-wireframes',
        version: '0',
        author: 'Matt DesLauriers',
        authorlink: 'https://github.com/mattdesl',
        license: 'MIT',
        licenselink:
            'https://github.com/mattdesl/webgl-wireframes/blob/gh-pages/LICENSE.md',
        githublink: 'https://github.com/mattdesl/webgl-wireframes',
    },
    {
        library: 'THREE.VRController',
        librarylink: 'https://github.com/stewdio/THREE.VRController',
        version: '0',
        author: 'Stewart Smith',
        authorlink: 'https://github.com/stewdio',
        license: 'MIT',
        licenselink:
            'https://github.com/stewdio/THREE.VRController/blob/master/LICENSE',
        githublink: 'https://github.com/stewdio/THREE.VRController',
    },
    {
        library: 'Turf',
        librarylink: 'https://turfjs.org/',
        version: '5.1.6',
        author: 'TurfJS',
        authorlink: 'https://github.com/Turfjs',
        license: 'MIT',
        licenselink: 'https://github.com/Turfjs/turf/blob/master/LICENSE',
        githublink: 'https://github.com/Turfjs/turf',
    },
    {
        library: 'MaterialDesignIcons (Font)',
        librarylink: 'https://materialdesignicons.com/',
        version: '0',
        author: 'Austin Andrews',
        authorlink: 'https://github.com/Templarian',
        license: 'SIL Open Font License',
        licenselink:
            'https://github.com/Templarian/MaterialDesign/blob/master/LICENSE',
        githublink: 'https://github.com/Templarian/MaterialDesign',
    },
    {
        library: 'Lato (Font)',
        librarylink: 'https://fonts.google.com/specimen/Lato',
        version: '2.015',
        author: 'Lukasz Dziedzic',
        authorlink: 'https://fonts.google.com/specimen/Lato',
        license: 'SIL Open Font License',
        licenselink:
            'https://github.com/google/fonts/blob/master/ofl/lato/OFL.txt',
        githublink: 'https://github.com/google/fonts/tree/master/ofl/lato',
    },
    {
        library: 'Roboto (Font)',
        librarylink: 'https://fonts.google.com/specimen/Roboto',
        version: '2.138',
        author: 'Christian Robertson',
        authorlink: 'https://fonts.google.com/specimen/Roboto',
        license: 'Apache-2.0',
        licenselink: 'https://github.com/google/roboto/blob/master/LICENSE',
        githublink: 'https://github.com/google/roboto/',
    },
    {
        library: 'Venus Rising (Font)',
        librarylink: 'https://www.dafont.com/venus-rising.font',
        version: '2.138',
        author: 'Typodermic Fonts',
        authorlink: 'http://typodermicfonts.com/',
        license: 'Custom (no embedding)',
        licenselink: 'http://typodermicfonts.com/license/',
        githublink: 'https://www.dafont.com/venus-rising.font',
    },
    {
        library: 'Globe Skysphere (Image)',
        librarylink: 'https://www.eso.org/public/usa/images/eso0932a/',
        version: '1',
        author: 'ESO/S. Brunier',
        authorlink: 'https://www.eso.org/public/',
        license: 'Creative Commons Attribution 4.0 International License',
        licenselink: 'https://www.eso.org/public/outreach/copyright/',
        githublink: 'https://www.eso.org/public/usa/images/eso0932a/',
    },
    {
        library: 'Marked',
        librarylink: 'https://marked.js.org/#/README.md#README.md',
        version: '0.8.0',
        author: 'markedjs',
        authorlink: 'https://github.com/markedjs',
        license: 'Custom',
        licenselink:
            'https://github.com/markedjs/marked/blob/master/LICENSE.md',
        githublink: 'https://github.com/markedjs/marked',
    },
]
